import axios from 'axios';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';

import { getApiUrl } from '@/helpers/api';

export const useOfferings = ({ coachId, coachActivityId }) => {
  const urlParams = new URLSearchParams();
  if (coachId) urlParams.append('coachId', coachId);
  if (coachActivityId) urlParams.append('coachActivityId', coachActivityId);
  const urlStr = `${getApiUrl()}/offering?${urlParams.toString()}`;

  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useOffering = (offeringId) => {
  const urlStr = `${getApiUrl()}/offering/${offeringId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const usePostOffering = () => {
  const postOffering = async (payload) => {
    try {
      const url = `${getApiUrl()}/offering`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postOffering;
};

export const usePutOffering = () => {
  const putOffering = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/offering/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putOffering;
};

export const useDeleteOffering = () => {
  const deleteOffering = async (id) => {
    try {
      const url = `${getApiUrl()}/offering/${id}`;
      await axios.delete(url);
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteOffering;
};

export const useOfferingObject = (offeringId) => {
  const params = useParams();
  const offerings = useOfferings({ coachId: params.id });
  return offerings.data.content[offeringId];
};
